module.exports = __webpack_public_path__ + "img/founder.ddde89a7.svg";